exports.TRANSITION_ENQUIRE = 'transition/enquire';
exports.TRANSITION_COMPLETE_ENQUIRE = 'transition/complete-enquire';
exports.TRANSITION_COMPLETE_ENQUIRE_OPERATOR = 'transition/complete-enquire-operator';
exports.TRANSITION_COMPLETE_ENQUIRE_CUSTOMER = 'transition/complete-enquire-customer';
